import styled, { css } from 'styled-components';
import { flexbox, space, layout, fontSize } from 'styled-system';
import { transparentize } from 'polished';

import { BadgeProps } from 'ui/types/component';

const Banner = styled.span<BadgeProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.space[2]};
  padding: ${({ theme }) => theme.space[2]} ${({ theme }) => theme.space[2]};
  font-size: 1rem;
  text-align: center;
  line-height: 1;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  white-space: nowrap;
  background-color: ${({ theme, variant }) =>
    variant === 'primary'
      ? theme.colors.primary
      : variant === 'info'
      ? theme.baseColors.blue[9]
      : variant === 'success'
      ? theme.baseColors.green[9]
      : variant === 'error'
      ? theme.baseColors.red[9]
      : variant === 'warning'
      ? theme.baseColors.yellow[8]
      : theme.colors.text.body};
  color: white;

  ${flexbox}
  ${space}
	${layout}
	${fontSize}
`;
export { Banner };
